import React from "react";
import "../assets/css/Home.css";
const Main = (props) => {
  return (
    <div className="content">
      <props.content
        {...props}
      />
    </div>
  );
};
export default Main;
